


























































































import { Component, Vue, Prop } from 'vue-property-decorator'
import {
  getOrgRole,
  addOrganization,
  UpdataOrganization,
  getOrganizationDetail,
  getOrganizationTree,
} from '@/api/system'

@Component({
  name: 'AddOrgModal',
  data() {
    return {
      form: this.$form.createForm(this),
    }
  },
})
export default class AddBasicModal extends Vue {
  @Prop({ type: Object }) readonly NodeTreeItem!: any;

  @Prop({ type: Number }) readonly status!: number;

  @Prop({ type: Boolean }) readonly visible!: boolean;

  private form: any;
  private isOrder:boolean = false
  private confirmLoading: boolean = false;

  private roleList: any[] = [];
  private TData: any[] = [];

  private formItemLayout: any = {
    labelCol: { span: 6 },
    wrapperCol: { span: 17 },
  };

  private detailMap: any = {}

  get title() {
    return this.status === 1 ? '添加下级组织' : '编辑组织'
  }

  public created() {
    if (this.status === 1) {
      this.$nextTick(() => {
        this.form.setFieldsValue({
          parentId: this.NodeTreeItem.title,
          roleId: 'c59e2c44f4b48e989c92f9a343d72198',
        })
      })
    } else if (this.status === 2 && this.NodeTreeItem.parentId === '0') {
      this.$nextTick(() => {
        this.form.setFieldsValue({
          orgName: this.NodeTreeItem.title,
        })
      })
    }
    this.getRoleList()
    if (this.status === 2 && this.NodeTreeItem.parentId) {
      this.getRoleDetail()
    }
    this.getOrgList()
  }

  private getOrgList() {
    getOrganizationTree().then((res: any) => {
      this.TData.push(res.data)
      this.TData = this.findIds(this.TData, this.NodeTreeItem.id)
    })
  }

  private findIds(data: any[], id?: any) {
    const list: any = []
    const setChild = (arr: any) => {
      arr.forEach((node: any) => {
        if (node.children && node.children.length > 0) {
          node.disabled = true
          setChild(node.children)
        } else {
          node.disabled = true
        }
      })
    }
    data.forEach((item: any) => {
      if (item.id === id) {
        item.disabled = true
        if (item.children && item.children.length > 0) {
          setChild(item.children)
        }
      } else {
        if (item.children && item.children.length > 0) {
          this.findIds(item.children, id)
        }
      }
    })
    return data
  }

  private async getRoleList() {
    try {
      // const { data } = await getOrgRole()
      // this.roleList = data.filter((item: any) => !item.roleCode)
    } catch (error:any) {
      throw new Error(error.message)
    }
  }

  private async getRoleDetail() {
    try {
      const { data } = await getOrganizationDetail(this.NodeTreeItem.id)
      this.detailMap = data
      this.$nextTick(() => {
        this.form.setFieldsValue({
          parentId: data.parentId,
          orgName: data.orgName,
          roleId: 'c59e2c44f4b48e989c92f9a343d72198',
        })
      })
    } catch (error:any) {
      throw new Error(error.message)
    }
  }

  public handleOk(): void {
    this.form.validateFields({ force: true }, (err: any, values: any) => {
      if (!err) {
        this.confirmLoading = true
        if (this.status === 1) {
          values.parentId = this.NodeTreeItem.id
        } else {
          values.id = this.NodeTreeItem.id,
          values.roleId = 'c59e2c44f4b48e989c92f9a343d72198',
          values.parentId = this.NodeTreeItem.parentId
        }
        const msg: string = this.status === 1 ? '添加成功' : '编辑成功'
        addOrganization(values).then((res: any) => {
          if (res && res.status === 0) {
            // UpdataOrganization({orgId:values.id,orgName:values.orgName}).then((respo:any) => {
            // })
            this.$message.success(msg)
          } else {
            this.$notification.error({
              message: '错误',
              description: res.message,
            })
          }
          setTimeout(() => {
            this.$emit('update:visible', false)
            this.$emit('closeModal1',2)
          }, 500)
        })
      }
      this.confirmLoading = false
    })
  }

  private changeOrg(val: string) {
    this.NodeTreeItem.parentId = val
  }

  public handleCancel(): void {
    this.$emit('update:visible', false)
  }
}
